import { createStore } from 'vuex';
import { login as apiLogin } from '@/utils/api';

export default createStore({
  state: {
    id_doctor: localStorage.getItem('id_doctor') || null,
    hotel_id:  localStorage.getItem('hotel_id')  || null,
    tipo_sesion: localStorage.getItem('tipo_sesion') || null,
    rango: localStorage.getItem('rango') || null,
  },
  mutations: {
    setUsuario(state, { id, rango }) { state.id_doctor = id; state.rango = rango; },
    setHotel(state, id)   { state.hotel_id  = id; },
    logout(state) {
      state.id_doctor  = null;
      state.hotel_id   = null;
      state.tipo_sesion = null;
      state.rango = null;
    },
  },
  actions: {
    async login({ commit }, credenciales) {
      let respuesta;
      try {
        respuesta = await apiLogin(credenciales.usuario, credenciales.contraseña);
      } catch (error) {
        return { exito: false, error: error.message };
      }

      localStorage.setItem('token', respuesta.token);
      localStorage.setItem('tipo_sesion', respuesta.tipo_sesion);

      if (respuesta.tipo_sesion === 'medico') {
        localStorage.setItem('id_doctor', respuesta.usuario.id);
        localStorage.setItem('rango', respuesta.usuario.rango);
        localStorage.removeItem('hotel_id');
        localStorage.removeItem('hotel_nombre');
        commit('setUsuario', { id: respuesta.usuario.id, rango: respuesta.usuario.rango });
        return { exito: true, tipo: 'medico' };
      }

      localStorage.setItem('hotel_id', respuesta.hotel.id);
      localStorage.setItem('hotel_nombre', respuesta.hotel.nombre);
      localStorage.removeItem('id_doctor');
      localStorage.removeItem('rango');
      commit('setHotel', respuesta.hotel.id);
      return { exito: true, tipo: 'hotel' };
    },
    logout({ commit }) {
      ['token', 'id_doctor', 'hotel_id', 'hotel_nombre', 'tipo_sesion', 'rango'].forEach((k) => localStorage.removeItem(k));
      commit('logout');
    },
  },
  getters: {
    usuarioAutenticado: state => !!(state.id_doctor || state.hotel_id),
    idDoctor: state => state.id_doctor,
  },
});
